import './AccountRegistration.scss';
import { map, isEmpty } from 'lodash';

import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import AccountRegistrationTable from 'components/layouts/Preferences/AccountRegistration/AccountRegistrationTable';
import PreferencesSection from 'components/layouts/Preferences/shared/PreferencesSection';
import { accountRegistrationFormsLink } from 'services/Externals';
import LinkButton from 'components/shared/Buttons/LinkButton';

const AccountRegistration = ({
  tableData,
  canViewBeneficiaries,
  hasOnlyViewOnly
}) => {
  const { retirementRegistrations, nonRetirementRegistrations } = tableData;

  return (
    <PreferencesSection className="account-registration-body" fullBackground>
      {!hasOnlyViewOnly && (
        <div className="account-registration-button-container">
          <LinkButton
            link={accountRegistrationFormsLink}
            linkTarget={'_blank'}
            className="account-registration-forms-button"
            text="View Forms"
            withPermissions={true}
          />
          {canViewBeneficiaries && (
            <Link
              to="/profile/beneficiaries"
              className="account-registration-beneficiary-button">
              Set Up Beneficiaries
            </Link>
          )}
        </div>
      )}
      <div className="account-registration-table-container">
        {!isEmpty(retirementRegistrations) && (
          <Fragment>
            <div className="account-registration-header">Retirement</div>
            {map(retirementRegistrations, (registration) => {
              return <AccountRegistrationTable registration={registration} />;
            })}
          </Fragment>
        )}
        {!isEmpty(nonRetirementRegistrations) && (
          <Fragment>
            <div className="account-registration-header">Non-Retirement</div>
            {map(nonRetirementRegistrations, (registration) => {
              return <AccountRegistrationTable registration={registration} />;
            })}
          </Fragment>
        )}
      </div>
    </PreferencesSection>
  );
};

export default AccountRegistration;
